import { makeStyles, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

export const useStyles = makeStyles(() =>
  createStyles({
    chatbotContainer: {
      zIndex: 1300,
      top: 'auto',
      right: '16px',
      bottom: '80px',
      left: 'auto',
      position: 'fixed',
      width: '376px',
      marginLeft: '15px',
      marginBottom: '20px',
    },
    fab: {
      height: '60px',
      width: '60px',
      top: 'auto',
      right: '16px',
      bottom: '16px',
      left: 'auto',
      position: 'fixed',
      color: colors.resiliaBlue,
      backgroundColor: colors.resiliaGreen,
      '&:hover': {
        backgroundColor: colors.resiliaGreen,
      },
    },
    chatbotContent: {
      color: 'black',
      fontWeight: 'bold',
      padding: '10px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      backgroundColor: colors.grey,
      height: '530px',
      width: '376px',
    },
  })
)
